// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".equipments .equipment {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 400px;\n  margin: 15px 15px 20px;\n}\n.equipments .equipment img {\n  width: 150px;\n  height: 150px;\n}\n.equipments .equipment h3 {\n  margin: 0 !important;\n  text-align: center;\n}\n.equipments .group-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}", ""]);
// Exports
module.exports = exports;
